import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MegamenuService } from 'src/app/modules/web/Services/megamenu.service'
import { environment as params } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent implements OnInit {
  
  urlBaseS3: any = (<any>params).api.s3;
  public isOpen = false;
  public isOpenMenu = false
  public data: any;
  public dataMobile:any;
  public dataTours;
  public dataToursSecc1;
  public dataToursSecc2;
  public dataToursSecc3;
  public dataToursSecc4;
  public dataSeguros;
  public dataSegurosSecc1;
  public dataSegurosSecc2;
  public dataSegurosSecc3;
  public dataSegurosSecc4;
  public dataVuelos;
  public dataVuelosSecc1;
  public dataVuelosSecc2;
  public dataVuelosSecc3;
  public dataVuelosSecc4;
  public dataHospedaje;
  public dataHospedajeSecc1;
  public dataHospedajeSecc2;
  public dataHospedajeSecc3;
  public dataHospedajeSecc4;
  public dataTransporte;
  public dataTransporteSecc1;
  public dataTransporteSecc2;
  public dataTransporteSecc3;
  public dataTransporteSecc4;
  public dataAccesorios;
  public accesoriosSecc1;
  public accesoriosSecc2;
  public accesoriosSecc3;
  public accesoriosSecc4;
  public dataEstudioExtranjero;
  public dataEstudioExtranjeroSec1;
  public dataEstudioExtranjeroSec2;
  public dataEstudioExtranjeroSec3;
  public dataEstudioExtranjeroSec4;
  public valueDiv = 0

  @Input('sociaMedia') public sociaMedia = [];
  @Input('loadServ') public loadServ: boolean = true;
  @Input('data') public generalData: any = [];
  public logo:string=''

  constructor( private _router: Router, private _wpService: MegamenuService,private _homeService: HomeService) {
  }

  ngOnInit() {
    this.getGeneralOptions();
    this._wpService.getMegamenuMobile().subscribe((result: any) => {
      this.dataMobile = result.json();
    },(err) => {console.log(err)});

    this._wpService.getMegamenu().subscribe((result: any) => {
      this.data = result.json();

      if(this.data){
        //Tours
        this.dataTours=this.data[0].acf;
        if(this.dataTours.key_rep_field_megamenu_desktop_seccirep){
          this.dataToursSecc1=(this.dataTours.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataTours.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataTours.key_rep_field_megamenu_desktop_seccirep[0]:null;
          this.dataToursSecc2=(this.dataTours.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataTours.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataTours.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataToursSecc3=(this.dataTours.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataTours.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataTours.key_rep_field_megamenu_desktop_seccirep[2]:null;//pendiente
          this.dataToursSecc4=(this.dataTours.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataTours.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataTours.key_rep_field_megamenu_desktop_seccirep[3]:null;

        }
        //$tipo = ["1" => "Single Text","2" => "Icono + Text","3" => "Programas","4" => "Full Image","5" => "Card","6" => "Box + text","7" => "background + text","8" => "Navigation"];
        //Seguros
        this.dataSeguros=this.data[1].acf;
        if(this.dataSeguros.key_rep_field_megamenu_desktop_seccirep){
          this.dataSegurosSecc1=(this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[0]:null;
          this.dataSegurosSecc2=(this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataSegurosSecc3=(this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.dataSegurosSecc4=(this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataSeguros.key_rep_field_megamenu_desktop_seccirep[3]:null;
        }

        this.dataVuelos=this.data[2].acf;
        if(this.dataVuelos.key_rep_field_megamenu_desktop_seccirep){
          this.dataVuelosSecc1=(this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[0]:null;
          this.dataVuelosSecc2=(this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataVuelosSecc3=(this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.dataVuelosSecc4=(this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataVuelos.key_rep_field_megamenu_desktop_seccirep[3]:null;  
        }
        
        this.dataHospedaje=this.data[3].acf;
        if(this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep){
          this.dataHospedajeSecc1=(this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[0]:null;//pendiente
          this.dataHospedajeSecc2=(this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataHospedajeSecc3=(this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.dataHospedajeSecc4=(this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataHospedaje.key_rep_field_megamenu_desktop_seccirep[3]:null;
        }
        
        this.dataTransporte=this.data[4].acf;
        if(this.dataTransporte.key_rep_field_megamenu_desktop_seccirep){
          this.dataTransporteSecc1=(this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[0]:null;//pendiente
          this.dataTransporteSecc2=(this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataTransporteSecc3=(this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.dataTransporteSecc4=(this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataTransporte.key_rep_field_megamenu_desktop_seccirep[3]:null;
        }
        
        this.dataAccesorios=this.data[5].acf;
        if(this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep){
          this.accesoriosSecc1=(this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[0]:null;//pendiente
          this.accesoriosSecc2=(this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.accesoriosSecc3=(this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.accesoriosSecc4=(this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataAccesorios.key_rep_field_megamenu_desktop_seccirep[3]:null;
        }

        this.dataEstudioExtranjero=this.data[6].acf;
        if(this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep){
          this.dataEstudioExtranjeroSec1=(this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[0] !== null && this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[0] !== undefined) ? this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[0]:null;//pendiente
          this.dataEstudioExtranjeroSec2=(this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[1] !== null && this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[1] !== undefined) ? this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[1]:null;
          this.dataEstudioExtranjeroSec3=(this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[2] !== null && this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[2] !== undefined) ? this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[2]:null;
          this.dataEstudioExtranjeroSec4=(this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[3] !== null && this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[3] !== undefined) ? this.dataEstudioExtranjero.key_rep_field_megamenu_desktop_seccirep[3]:null;
        }
        
      }


    },(err) => {console.log(err)});
  }
  /*openNav() {
    if(!this.isOpen){
      document.getElementById("myNav").style.display = "block";
      document.getElementById("myNav").style.height = "100%";
      setTimeout(function(){
      }, 5000);
      this.isOpen = true;
    } else{
      document.getElementById("myNav").style.height = "0%";
      setTimeout(function(){
        document.getElementById("myNav").style.display = "none";
      }, 5000);
      this.isOpen = false;
    }
  }*/

  openNav() {
    if(!this.isOpen){
      document.getElementById("myNav").style.height = "100%";
      this.isOpen = true;
    }
  }

  closeNav() {
    if(this.isOpen){
      document.getElementById("myNav").style.height = "0%";
      this.isOpen = false;
    }
  }

  openMenu(tipo: string){
    //setTimeout(function(){
    //  document.getElementById("modal"+tipo).style.display = "block";
  //  }, 500);    
    //document.getElementById("tabpills_0").style.display = "block";
  }

  closeMenu(tipo: string){
  //setTimeout(function(){
   //   document.getElementById("modal"+tipo).style.display = "none";
    //}, 500);
  /*for(let i=0; i<15;i++){
    let comp =document.getElementById("tabpills_"+i);
    if(comp != null){
      document.getElementById("tabpills_"+i).style.display = "none";
    }
  }*/
  }

 closeMenuModal(tipo: string){
   console.log("fuera del  menu modal ")
 }

 openMenuModal(tipo: string){

   console.log("open menu modal ")
 }

  abrirsubmenu(modal:string, i:number){  
    //setTimeout(function(){
      document.getElementById("myNav").style.height = "0%";
      document.getElementById(modal).style.height = "100%";
      this.valueDiv=i;
    //}, 60000);    
    
  }

  volversubmenu(modal:string){  
    document.getElementById(modal).style.height = "0%";
    document.getElementById("myNav").style.height = "100%";
  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks;
    
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    
    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }   

  urlGenerada(url:string){
   if(url!=""){

    let comprobar = url.indexOf("http");

    if(comprobar < 0){
      this._router.navigateByUrl(url);
    }else{
      window.location.href = url;
    }

   //
   // //console.log("Ir a esta pagina: "+url+" "+comprobar);
     }else{
       // console.log("No hacer nada");
     }
   }

  abrirmini(numero: string){

    var x = document.getElementById(numero);
    if (window.getComputedStyle(x).display === "none") {
      x.style.display = "block";
    }else{
    x.style.display = "none";
    }
  }

  pintaCotiza(texto:string){
    //console.log("pinta cotiza:  ", texto)
    //let comprobar = texto.includes("Un tipo de seguro para cada viajero");
    if(texto.includes("Un tipo de seguro para cada viajero")){
      return true
    }else{
      return false
    }
  }

  cambiaLink(texto:string){
    
    if(texto.includes("Hoteles en destinos mas buscados")){
      return true
    }else if(texto.includes("Destinos mas populares")){
      return true
    }else if(texto.includes("Otros Servicios")){
      return true
    }else{
      return false
    }
  }

  getGeneralOptions() {
    this._homeService.getGeneralOptions().subscribe(data => {

      const social_media = [];
      const logo = ''

      // tslint:disable-next-line: forin
      if (data.data) {
        for (const prop in data.data.socials.data) {
          if (prop !== 'options') {
            social_media.push(data.data.socials.data[prop]);
          }
        }
      }
      this.sociaMedia = social_media;
      this.generalData = data.data;
      this.logo=this.urlBaseS3 + data.data.logo.url
      if (!(data.data && data.data.length > 0)) {
        console.warn('Sin data general');
      }
    }, err => {
      console.error(err);
    });
  }

  url(urlBaseS3:string, logo:any){
    return urlBaseS3 + logo.url

  }

}